// TODO: Get rid of this list, bring everything to the use of 1 single list `allGames`.
// TODO: Where categories are needed, instead of category 1, make an array of categories
// TODO: CAF category has different redirect urls
/**
 * Game cards
 * @type {[{image: string, gameType: string, gameIdFF: string, isFastPlay: boolean, title: string, category: string, comingSoon: boolean, hidden: boolean}]}
 */
export const gameCards = [
  {
    title: 'Max Dice',
    image: '/images/cards/fastplay/MaxDice.png?v=2',
    category: 'FP',
    gameIdFF: '7',
    isFastPlay: true,
    extendedParams: true,
    gameType: 'max-dice',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV), //!!
  },
  {
    title: 'Sector X',
    image: '/images/cards/hp/sx.webp?v=2',
    category: 'FP',
    gameIdFF: '866',
    isFastPlay: true,
    gameType: 'sector-x',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Dragon Stone',
    image: '/images/cards/hp/ds.webp?v=2',
    category: 'FP',
    gameIdFF: '838',
    isFastPlay: true,
    gameType: 'dragonstone',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Mission Amazon',
    image: '/images/cards/hp/ma.webp?v=2',
    category: 'FP',
    gameIdFF: '859',
    isFastPlay: true,
    gameType: 'mission-amazon',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Triple Max Blast',
    image: '/images/cards/hp/tmb.webp?v=3',
    category: 'FP',
    gameIdFF: '875',
    isFastPlay: true,
    gameType: 'maxblast',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Olympus Plinko',
    image: '/images/cards/hp/op.webp?v=1',
    category: 'FP',
    redirect: 'fastplay',
    gameIdExtended: 11,
    isFastPlay: true,
    gameType: 'plinko',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Fast Mines',
    image: '/images/cards/hp/fm.webp?v=1',
    category: 'FP',
    redirect: 'fastplay',
    gameIdFF: '8',
    isFastPlay: true,
    extendedParams: true,
    gameType: 'multi-mines',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Return of Ra',
    image: '/images/cards/hp/ror.webp?v=1',
    category: 'FP',
    redirect: 'fastplay',
    comingSoon: true,
    isFastPlay: true,
    gameType: 'return-of-ra',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Sector X',
    image: '/images/cards/hp/pvp-sx.webp?v=1',
    category: 'PVP',
    gameType: 'sector-x',
  },
  {
    title: 'Dragon Stone',
    image: '/images/cards/hp/pvp-ds.webp?v=1',
    category: 'PVP',
    gameType: 'dragonstone',
  },
  {
    title: 'Mission Amazon',
    image: '/images/cards/hp/pvp-ma.webp?v=1',
    category: 'PVP',
    gameType: 'mission-amazon',
  },
  {
    title: 'Max Plosion Royale',
    image: '/images/cards/hp/pvp-mpl.webp?v=1',
    category: 'PVP',
    gameType: 'maxplosion',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Max Blast Champs',
    image: '/images/cards/hp/pvp-mbc.webp?v=2',
    category: 'PVP',
    redirect: 'maxblastchamps',
    gameType: 'maxblast',
  },
  {
    title: 'Multi Mines',
    image: '/images/cards/hp/pvp-mm.webp?v=1',
    category: 'PVP',
    gameType: 'multi-mines',
  },
  {
    title: 'Roll Or Hold',
    image: '/images/cards/hp/pvp-roh.webp?v=1',
    category: 'PVP',
    gameType: 'rolling-21',
    comingSoon: true,
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Return of Ra',
    image: '/images/cards/hp/pvp-ror.webp?v=1',
    category: 'PVP',
    comingSoon: true,
    gameType: 'return-of-ra',
  },
  {
    title: 'Multi Plinko',
    image: '/images/cards/hp/pvp-mp.webp?v=1',
    category: 'PVP',
    redirect: 'multiplinko',
    gameType: 'plinko',
  },
  {
    title: 'Rolling 21',
    image: '/images/cards/hp/pvp-r21.webp?v=1',
    category: 'PVP',
    redirect: 'playervsplayer/rolling-21',
    gameType: 'rolling-21',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Escape The Circle',
    image: '/images/cards/hp/pvp-etc.webp?v=1',
    category: 'PVP',
    redirect: 'playervsplayer/escape-the-circle',
    gameType: 'escape-the-circle',
    hidden: process.env.NODE_ENV !== 'maxquest',
  },
  {
    title: 'Escape the Circle Xtreme',
    image: '/images/cards/hp/pvp-etc-xtreme.webp?v=2',
    category: 'PVP',
    gameType: 'escape-the-circle-xtreme',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Sector X',
    image: '/images/cards/hp/pvp-sx.webp?v=1',
    category: 'CAF',
    redirect: 'challengefriends/challenge',
    gameType: 'sector-x',
  },
  {
    title: 'Dragon Stone',
    image: '/images/cards/hp/pvp-ds.webp?v=1',
    category: 'CAF',
    redirect: 'challengefriends/challenge',
    gameType: 'dragonstone',
  },
  {
    title: 'Mission Amazon',
    image: '/images/cards/hp/pvp-ma.webp?v=1',
    category: 'CAF',
    redirect: 'challengefriends/challenge',
    gameType: 'mission-amazon',
  },
  {
    title: 'Max Blast Champs',
    image: '/images/cards/hp/pvp-mbc.webp?v=2',
    category: 'CAF',
    redirect: 'challengefriends/challenge',
    gameType: 'maxblast',
  },
  {
    title: 'Return of Ra',
    image: '/images/cards/hp/pvp-ror.webp?v=1',
    category: 'CAF',
    redirect: 'challengefriends/challenge',
    gameType: 'return-of-ra',
    comingSoon: true,
  },
  {
    title: 'Scarab Plinko',
    image: '/images/cards/hp/pvp-sp.webp?v=4',
    category: 'PVP',
    gameType: 'scarab-plinko',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Max Blocks',
    image: '/images/cards/hp/pvp-mb.webp?v=2',
    category: 'PVP',
    gameType: 'max-blocks',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  // for game title carousels
  {
    title: 'Multi Plinko',
    image: '/images/cards/hp/pvp-mp.webp?v=1',
    category: 'gameTitles',
    carouselTitle: 'Plinko',
    redirect: 'multiplinko',
    gameType: 'plinko',
  },
  {
    title: 'Olympus Plinko',
    image: '/images/cards/hp/op.webp?v=1',
    category: 'gameTitles',
    carouselTitle: 'Plinko',
    redirect: 'plinko',
    gameIdExtended: 11,
    isFastPlay: true,
    gameType: 'plinko',
    hidden: process.env.NODE_ENV !== 'maxquest',
  },
  {
    title: 'Max Blast Champs',
    image: '/images/cards/hp/pvp-mbc.webp?v=2',
    category: 'gameTitles',
    carouselTitle: 'Max Blast',
    redirect: 'maxblastchamps',
    gameType: 'maxblast',
  },
  {
    title: 'Triple Max Blast',
    image: '/images/cards/hp/tmb.webp?v=3',
    category: 'gameTitles',
    carouselTitle: 'Max Blast',
    redirect: 'maxblast',
    gameIdFF: '875',
    isFastPlay: true,
    gameType: 'maxblast',
    hidden: process.env.NODE_ENV !== 'maxquest',
  },
  {
    title: 'Sector X',
    image: '/images/cards/hp/pvp-sx.webp?v=1',
    category: 'gameTitles',
    carouselTitle: 'Sector X',
    gameType: 'sector-x',
  },
  {
    title: 'Sector X',
    image: '/images/cards/hp/sx.webp?v=1',
    category: 'gameTitles',
    carouselTitle: 'Sector X',
    gameIdFF: '866',
    isFastPlay: true,
    gameType: 'sector-x',
  },
  {
    title: 'Mission Amazon',
    image: '/images/cards/hp/pvp-ma.webp?v=1',
    category: 'gameTitles',
    carouselTitle: 'Mission: Amazon',
    gameType: 'mission-amazon',
  },
  {
    title: 'Mission Amazon',
    image: '/images/cards/hp/ma.webp?v=1',
    category: 'gameTitles',
    carouselTitle: 'Mission: Amazon',
    gameIdFF: '859',
    isFastPlay: true,
    gameType: 'mission-amazon',
  },
  {
    title: 'Dragon Stone',
    image: '/images/cards/hp/pvp-ds.webp?v=1',
    category: 'gameTitles',
    carouselTitle: 'Dragon Stone',
    gameType: 'dragonstone',
  },
  {
    title: 'Dragon Stone',
    image: '/images/cards/hp/ds.webp?v=1',
    category: 'gameTitles',
    carouselTitle: 'Dragon Stone',
    gameIdFF: '838',
    isFastPlay: true,
    gameType: 'dragonstone',
  },
  // fish table
  {
    title: 'Sector X',
    image: '/images/cards/hp/pvp-sx.webp?v=1',
    category: 'FishTable',
    gameType: 'sector-x',
  },
  {
    title: 'Dragon Stone',
    image: '/images/cards/hp/pvp-ds.webp?v=1',
    category: 'FishTable',
    gameType: 'dragonstone',
  },
  {
    title: 'Mission Amazon',
    image: '/images/cards/hp/pvp-ma.webp?v=1',
    category: 'FishTable',
    gameType: 'mission-amazon',
  },
  {
    title: 'Duel 21',
    image: '/images/cards/hp/pvp-d21.webp?v=1',
    category: 'PVP',
    gameType: 'duel-21',
  },
];

export const allGames = [
  {
    title: 'Olympus Plinko',
    image: '/images/cards/hp/op.webp?v=1',
    category: 'FP',
    redirect: 'fastplay',
    gameIdExtended: 11,
    isFastPlay: true,
    gameType: 'plinko',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Multi Plinko',
    image: '/images/cards/hp/pvp-mp.webp?v=1',
    category: 'PVP',
    redirect: 'multiplinko',
    gameType: 'plinko',
  },
  {
    title: 'Fast Mines',
    image: '/images/cards/hp/fm.webp?v=1',
    category: 'FP',
    redirect: 'fastplay',
    isFastPlay: true,
    gameIdFF: '8',
    extendedParams: true,
    gameType: 'multi-mines',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Multi Mines',
    image: '/images/cards/hp/pvp-mm.webp?v=1',
    category: 'PVP',
    gameType: 'multi-mines',
  },
  {
    title: 'Triple Max Blast',
    image: '/images/cards/hp/tmb.webp?v=3',
    category: 'FP',
    gameIdFF: '875',
    isFastPlay: true,
    gameType: 'maxblast',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Max Blast Champs',
    image: '/images/cards/hp/pvp-mbc.webp?v=2',
    category: 'PVP',
    redirect: 'maxblastchamps',
    gameType: 'maxblast',
  },
  {
    title: 'Sector X',
    image: '/images/cards/hp/sx.webp?v=1',
    category: 'FP',
    gameIdFF: '866',
    isFastPlay: true,
    gameType: 'sector-x',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Sector X',
    image: '/images/cards/hp/pvp-sx.webp?v=1',
    category: 'PVP',
    gameType: 'sector-x',
  },
  {
    title: 'Dragon Stone',
    image: '/images/cards/hp/ds.webp?v=1',
    category: 'FP',
    gameIdFF: '838',
    isFastPlay: true,
    gameType: 'dragonstone',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Dragon Stone',
    image: '/images/cards/hp/pvp-ds.webp?v=1',
    category: 'PVP',
    gameType: 'dragonstone',
  },
  {
    title: 'Mission Amazon',
    image: '/images/cards/hp/ma.webp?v=1',
    category: 'FP',
    gameIdFF: '859',
    isFastPlay: true,
    gameType: 'mission-amazon',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Mission Amazon',
    image: '/images/cards/hp/pvp-ma.webp?v=1',
    category: 'PVP',
    gameType: 'mission-amazon',
  },
  {
    title: 'Return of Ra',
    image: '/images/cards/hp/ror.webp?v=1',
    category: 'FP',
    redirect: 'fastplay',
    isFastPlay: true,
    comingSoon: true,
    gameType: 'return-of-ra',
    hidden: !['development', 'maxquest'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Max Plosion Royale',
    image: '/images/cards/hp/pvp-mpl.webp?v=1',
    category: 'PVP',
    gameType: 'maxplosion',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Return of Ra',
    image: '/images/cards/hp/pvp-ror.webp?v=1',
    category: 'PVP',
    comingSoon: true,
    gameType: 'return-of-ra',
  },
  {
    title: 'Roll Or Hold',
    image: '/images/cards/hp/pvp-roh.webp?v=1',
    category: 'PVP',
    redirect: 'playervsplayer/roll-or-hold',
    gameType: 'roll-or-hold',
    hidden: process.env.NODE_ENV !== 'maxquest',
  },
  {
    title: 'Rolling 21',
    image: '/images/cards/hp/pvp-r21.webp?v=1',
    category: 'PVP',
    redirect: 'playervsplayer/rolling-21',
    gameType: 'rolling-21',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Escape The Circle',
    image: '/images/cards/hp/pvp-etc.webp?v=1',
    category: 'PVP',
    redirect: 'playervsplayer/escape-the-circle',
    gameType: 'escape-the-circle',
    hidden: process.env.NODE_ENV !== 'maxquest',
  },
  {
    title: 'Escape the Circle Xtreme',
    image: '/images/cards/hp/pvp-etc-xtreme.webp?v=2',
    category: 'PVP',
    gameType: 'escape-the-circle-xtreme',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Scarab Plinko',
    image: '/images/cards/hp/pvp-sp.webp?v=2',
    category: 'PVP',
    gameType: 'scarab-plinko',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Max Blocks',
    image: '/images/cards/hp/pvp-mb.webp?v=2',
    category: 'PVP',
    gameType: 'max-blocks',
    hidden: !['maxquest', 'development'].includes(process.env.NODE_ENV),
  },
  {
    title: 'Duel 21',
    image: '/images/cards/hp/pvp-d21.webp?v=1',
    category: 'PVP',
    gameType: 'duel-21',
  },
];

export const availableGameTypes = new Set(allGames.map((game) => game.gameType));

export const gameInfos = {
  'sector-x': {
    fastplay: [
      {
        svgIcon: 'Alien',
        text: '<strong>Aim</strong> for the capsules for increased prizes',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Target</strong> the mega enemies to win up to 300x your bid',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Defeat</strong> one of the four bosses and earn big rewards',
      },
    ],
    pvp: [
      {
        svgIcon: 'Alien',
        text: '<strong>Aim</strong> for the capsules to unlock special drops',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Target</strong> the mega enemies to win up to 300x your bid',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Defeat</strong> one of the four bosses to increase your score',
      },
    ],
  },
  dragonstone: {
    fastplay: [
      {
        svgIcon: 'Trophy',
        text: '<strong>Collect</strong> 8 DragonStone fragments to summon the Dragon',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Target</strong> the Lightning Specter for increased rewards',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Defeat</strong> the Dragon and win up to 250x your bid',
      },
    ],
    pvp: [
      {
        svgIcon: 'Trophy',
        text: '<strong>Collect</strong> 8 DragonStone fragments to summon the Dragon',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Use</strong> special weapons for maximum damage',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Defeat</strong> the Dragon and win huge rewards',
      },
    ],
  },
  'mission-amazon': {
    fastplay: [
      {
        svgIcon: 'Monkey',
        text: '<strong>Collect</strong> rare gems and win up to 70x your bid',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Use</strong> special weapons to defeat up to 26 enemies',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Defeat</strong> the legendary bosses and win up to 100x your bid',
      },
    ],
    pvp: [
      {
        svgIcon: 'Monkey',
        text: '<strong>Collect</strong> rare gems to increase your score',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Obliterate</strong> the weapon carries to unlock special weapons',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Defeat</strong> the legendary bosses and win big rewards',
      },
    ],
  },
  'return-of-ra': {
    fastplay: [
      {
        svgIcon: 'Receive',
        text: '<strong>Receive</strong> payouts up to 500x by defeating Anubis',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Critical hits</strong> award up to a 7x multiplier to your score',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Use</strong> special weapons to crush your enemies',
      },
    ],
    pvp: [
      {
        svgIcon: 'Receive',
        text: '<strong>Receive</strong> payouts up to 500x by defeating Anubis',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Critical hits</strong> award up to a 7x multiplier to your score',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Use</strong> special weapons to crush your enemies',
      },
    ],
  },
  'rolling-21': {
    fastplay: [],
    pvp: [
      {
        svgIcon: 'Cube',
        text: '<strong>Three</strong> chances to roll the dice closest to 21',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Roll</strong> again if you get snake eyes',
      },
      {
        svgIcon: 'Use',
        text: '<strong>The player</strong> who gets closest to 21 without going over wins the prize pot',
      },
    ],
  },
  'roll-or-hold': {
    fastplay: [],
    pvp: [
      {
        svgIcon: 'Cube',
        text: '<strong>Three</strong> chances to roll the dice  closest to 100',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Hold</strong> if you think you have the score  to beat',
      },
      {
        svgIcon: 'Use',
        text: '<strong>The player</strong> with the highest score  wins the entire PRIZE POT',
      },
    ],
  },
  'multi-mines': {
    fastplay: [
      {
        svgIcon: 'Diamond',
        text: '<strong>Click</strong> tiles to reveal Gems or Mines.',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Gems</strong> increase your payout multiplier. Uncovering a mine ends the game.',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Gem</strong> multiplier increases with the number of mines.',
      },
    ],
    pvp: [
      {
        svgIcon: 'Diamond',
        text: '<strong>Select</strong> one square in each of the five rounds and find hidden gems',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Focus</strong> on the multipliers and stay clear of the mines',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Achieve</strong> the highest score to win the entire prize pot',
      },
    ],
  },
  maxblast: {
    fastplay: [
      {
        svgIcon: 'Rocket',
        text: '<strong>Control</strong> up to 3 astronauts through space in one round',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Eject</strong> before the rocket collides with an asteroid',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Win</strong> up to 100x your bid by successfully jumping out',
      },
    ],
    pvp: [
      {
        svgIcon: 'Rocket',
        text: '<strong>Blast</strong> into space with up to 50 players',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Aim</strong> to be the last astronaut to eject before the rocket crashes',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Ensure</strong> the win to take home the entire prize pot',
      },
    ],
  },
  plinko: {
    fastplay: [
      {
        svgIcon: 'SpecialWeapon',
        text: '<strong>Launch</strong> up to 100 balls in a single round aiming for the multipliers',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Activate</strong> the Bonus and Jackpot Wheels for increased prizes',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Use</strong> the turbocharge feature to speed up rounds by 30%',
      },
    ],
    pvp: [
      {
        svgIcon: 'SpecialWeapon',
        text: '<strong>Target</strong> the multipliers to achieve the highest score',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Use</strong> the bump feature to change the balls direction',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Win</strong> the round and take home the entire prize pot',
      },
    ],
  },
  'max-21': {
    fastplay: [
      {
        svgIcon: 'Cube',
        text: '<strong>Three</strong> rounds to get 21 without going over',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Roll</strong> double 5s or 6s to double your bid',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Score</strong> exactly 21 for a special bonus win',
      },
    ],
    pvp: [],
  },
  'max-dice': {
    fastplay: [
      {
        svgIcon: 'Cube',
        text: '<strong>Three</strong> chances to Roll to 100 without going over',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Hold</strong> on the highest score for the best outcome',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Score</strong> a perfect 100 for a 2.5x win',
      },
    ],
    pvp: [],
  },
  fastmines: {
    fastplay: [
      {
        svgIcon: 'Diamond',
        text: '<strong>Click</strong> tiles to reveal Gems or Mines',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Gems</strong> increase your payout multiplier. Uncovering a mine ends the game',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Gem</strong> multiplier increases with the number of mines',
      },
    ],
    pvp: [],
  },
  'escape-the-circle': {
    fastplay: [],
    pvp: [
      {
        svgIcon: 'SpecialWeapon',
        text: '<strong>Be</strong> the first to escape and win the pot!',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Strategize</strong> by choosing where to drop your ball!',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Compete</strong> with up to 4 players in every round!',
      },
    ],
  },
  'escape-the-circle-xtreme': {
    fastplay: [],
    pvp: [
      {
        svgIcon: 'SpecialWeapon',
        text: '<strong>Be</strong> the first to escape and win the pot!',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Strategize</strong> by choosing where to drop your ball!',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Compete</strong> with up to 4 players in every round!',
      },
    ],
  },
  'scarab-plinko': {
    fastplay: [],
    pvp: [
      {
        svgIcon: 'SpecialWeapon',
        text: '<strong>Hit</strong> scarabs to apply multipliers to your score.',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Use</strong> the bump to the left or right to control ball direction and improve your score',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Win</strong> the round to claim the prize pot.',
      },
    ],
  },
  'max-blocks': {
    fastplay: [],
    pvp: [
      {
        svgIcon: 'SpecialWeapon',
        text: '<strong>Find</strong> more treasures than your opponents and claim the prize!',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>The numbers</strong> indicate how far away the valuable metals are.',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Up to 4 players</strong> can mine at the same time!',
      },
    ],
  },
  maxplosion: {
    fastplay: [],
    pvp: [
      {
        svgIcon: 'SpecialWeapon',
        text: '<strong>Compete</strong> in matches where the last one standing wins.',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Use</strong> bombs to destroy walls, trap, and eliminate opponents',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Collect</strong> power-ups to boost speed, bomb capacity, and blast radius.',
      },
    ],
  },
  'duel-21': {
    fastplay: [],
    pvp: [
      {
        svgIcon: 'SpecialWeapon',
        text: '<strong>Stack</strong> cards to hit exactly 21 and earn big points',
      },
      {
        svgIcon: 'Defeat',
        text: '<strong>Watch out</strong> - 3 busts and it’s game over',
      },
      {
        svgIcon: 'Use',
        text: '<strong>Use</strong> wild Black Jacks to clear stacks instantly',
      },
    ],
  },
};

export const gameDescriptions = {
  dragonstone: 'Beat real players in 90-seconds of non-stop Player vs Player action to win the entire prize pot.',

  'mission-amazon': 'Take down the entire prize pot every 90 seconds in Player vs Player rounds.',

  'sector-x': 'Compete in 60-second Player vs Player rounds to claim the entire prize pot.',

  plinko: 'Play reimagined and unique Plinko games - earn up to 9x in Player vs Player.',

  maxblast:
    'Discover the first-of-its-kind versions of popular Crash Games - compete in Player vs Player to claim the prize pot.',

  'multi-mines':
    'Compete against 5 other players for the prize pot navigating a strategic minefield in this high-stakes game in Player vs Player.',

  'scarab-plinko':
    'Up to 10 players compete for the prize pool, each starting with 3 chips. You can hit scarabs for multipliers and use bumps to steer your balls. The player with the highest score at the end wins the prize.',

  'max-blocks': 'TODO: add desc',
  'duel-21':
    'A fast-paced card game combining Blackjack and Solitaire, where up to 50 players compete simultaneously to build stacks totaling 21 without busting',
};

export const gameNamesById = {
  838: 'Dragon Stone',
  856: 'Dragon Stone',
  859: 'Mission Amazon',
  862: 'Mission Amazon',
  864: 'Max Blast Champs',
  866: 'Sector X',
  867: 'Sector X',
  875: 'Triple Max Blast',
  1: 'Multiplinko',
  2: 'Roll Or Hold',
  5: 'Rolling 21',
  6: 'MultiMines',
  10: 'Escape The Circle',
  12: 'Scarab Plinko',
  14: 'Max Blocks',
  15: 'Max Plosion Royale',
  16: 'Duel 21',
};

export const availableGames = gameCards.filter((game) => !game.comingSoon && !game.hidden);

export const roomsConfig = {
  MMC: {
    maxblast: [
      {
        maxPrize: '45', // please use string as it is used as a path to image
        playersMax: 50,
        roundTime: 30,
        buyInAmount: 1,
      },
      {
        maxPrize: '90',
        playersMax: 50,
        roundTime: 30,
        buyInAmount: 2,
      },
      {
        maxPrize: '225',
        playersMax: 50,
        roundTime: 30,
        buyInAmount: 5,
      },
      {
        maxPrize: '450',
        playersMax: 50,
        roundTime: 30,
        buyInAmount: 10,
      },
      {
        maxPrize: '900',
        playersMax: 50,
        roundTime: 30,
        buyInAmount: 20,
      },
    ],
    'sector-x': [
      {
        maxPrize: '5.40',
        playersMax: 6,
        roundTime: 60,
        buyInAmount: 1,
      },
      {
        maxPrize: '10.80',
        playersMax: 6,
        roundTime: 60,
        buyInAmount: 2,
      },
      {
        maxPrize: '27',
        playersMax: 6,
        roundTime: 60,
        buyInAmount: 5,
      },
    ],
    plinko: [
      {
        maxPrize: '9',
        playersMax: 10,
        roundTime: 10,
        buyInAmount: 1,
      },
      {
        maxPrize: '18',
        playersMax: 10,
        roundTime: 10,
        buyInAmount: 2,
      },
      {
        maxPrize: '45',
        playersMax: 10,
        roundTime: 10,
        buyInAmount: 5,
      },
      {
        maxPrize: '90',
        playersMax: 10,
        roundTime: 10,
        buyInAmount: 10,
      },
      {
        maxPrize: '180',
        playersMax: 10,
        roundTime: 10,
        buyInAmount: 20,
      },
    ],
    'multi-mines': [
      {
        maxPrize: '4.50',
        playersMax: 5,
        roundTime: 60,
        buyInAmount: 1,
      },
      {
        maxPrize: '9',
        playersMax: 5,
        roundTime: 60,
        buyInAmount: 2,
      },
      {
        maxPrize: '22.50',
        playersMax: 5,
        roundTime: 60,
        buyInAmount: 5,
      },
    ],
    dragonstone: [
      {
        maxPrize: '5.40',
        playersMax: 6,
        roundTime: 90,
        buyInAmount: 1,
      },
      {
        maxPrize: '10.80',
        playersMax: 6,
        roundTime: 90,
        buyInAmount: 2,
      },
      {
        maxPrize: '27',
        playersMax: 6,
        roundTime: 90,
        buyInAmount: 5,
      },
    ],
    'mission-amazon': [
      {
        maxPrize: '5.40',
        playersMax: 6,
        roundTime: 90,
        buyInAmount: 1,
      },
      {
        maxPrize: '10.80',
        playersMax: 6,
        roundTime: 90,
        buyInAmount: 2,
      },
      {
        maxPrize: '27',
        playersMax: 6,
        roundTime: 90,
        buyInAmount: 5,
      },
    ],
    'rolling-21': [
      {
        maxPrize: '7.20',
        playersMax: 9,
        roundTime: 10,
        buyInAmount: 1,
      },
      {
        maxPrize: '14.40',
        playersMax: 9,
        roundTime: 10,
        buyInAmount: 2,
      },
      {
        maxPrize: '36',
        playersMax: 9,
        roundTime: 10,
        buyInAmount: 5,
      },
    ],
    'roll-or-hold': [
      {
        maxPrize: '8.10',
        playersMax: 9,
        roundTime: 20,
        buyInAmount: 1,
      },
      {
        maxPrize: '16.20',
        playersMax: 9,
        roundTime: 20,
        buyInAmount: 2,
      },
      {
        maxPrize: '40.50',
        playersMax: 9,
        roundTime: 20,
        buyInAmount: 5,
      },
    ],
    'escape-the-circle': [
      {
        maxPrize: '3.60',
        playersMax: 4,
        roundTime: 20,
        buyInAmount: 1,
      },
      {
        maxPrize: '7.20',
        playersMax: 4,
        roundTime: 20,
        buyInAmount: 2,
      },
      {
        maxPrize: '18',
        playersMax: 4,
        roundTime: 20,
        buyInAmount: 5,
      },
    ],
    'escape-the-circle-xtreme': [
      {
        maxPrize: '7.20',
        playersMax: 8,
        roundTime: 20,
        buyInAmount: 1,
      },
      {
        maxPrize: '14.40',
        playersMax: 8,
        roundTime: 20,
        buyInAmount: 2,
      },
      {
        maxPrize: '36',
        playersMax: 8,
        roundTime: 20,
        buyInAmount: 5,
      },
    ],
    'scarab-plinko': [
      {
        maxPrize: '9',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 1,
      },
      {
        maxPrize: '18',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 2,
      },
      {
        maxPrize: '45',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 5,
      },
      {
        maxPrize: '90',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 10,
      },
      {
        maxPrize: '180',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 20,
      },
      {
        maxPrize: '450',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 50,
      },
    ],
    'max-blocks': [
      {
        maxPrize: '9',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 1,
      },
      {
        maxPrize: '18',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 2,
      },
      {
        maxPrize: '45',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 5,
      },
      {
        maxPrize: '90',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 10,
      },
      {
        maxPrize: '180',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 20,
      },
      {
        maxPrize: '450',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 50,
      },
    ],
    maxplosion: [
      {
        maxPrize: '3.60',
        playersMax: 4,
        roundTime: 120,
        buyInAmount: 1,
      },
      {
        maxPrize: '7.20',
        playersMax: 4,
        roundTime: 120,
        buyInAmount: 2,
      },
      {
        maxPrize: '18',
        playersMax: 4,
        roundTime: 120,
        buyInAmount: 5,
      },
      {
        maxPrize: '36',
        playersMax: 4,
        roundTime: 120,
        buyInAmount: 10,
      },
      {
        maxPrize: '72',
        playersMax: 4,
        roundTime: 120,
        buyInAmount: 20,
      },
      {
        maxPrize: '180',
        playersMax: 4,
        roundTime: 120,
        buyInAmount: 50,
      },
    ],
    'duel-21': [
      {
        maxPrize: '45',
        playersMax: 50,
        roundTime: 240,
        buyInAmount: 1,
      },
      {
        maxPrize: '90',
        playersMax: 50,
        roundTime: 240,
        buyInAmount: 2,
      },
      {
        maxPrize: '225',
        playersMax: 50,
        roundTime: 240,
        buyInAmount: 5,
      },
      {
        maxPrize: '450',
        playersMax: 50,
        roundTime: 240,
        buyInAmount: 10,
      },
      {
        maxPrize: '900',
        playersMax: 50,
        roundTime: 240,
        buyInAmount: 20,
      },
    ],
  },
  MQC: {
    maxblast: [
      {
        maxPrize: '90K', // please use string as it is used as a path to image
        playersMax: 50,
        roundTime: 30,
        buyInAmount: 2000,
      },
    ],
    'sector-x': [
      {
        maxPrize: '10.8K',
        playersMax: 6,
        roundTime: 60,
        buyInAmount: 2000,
      },
    ],
    plinko: [
      {
        maxPrize: '18K',
        playersMax: 10,
        roundTime: 10,
        buyInAmount: 2000,
      },
    ],
    'multi-mines': [
      {
        maxPrize: '9K',
        playersMax: 5,
        roundTime: 60,
        buyInAmount: 2000,
      },
    ],
    dragonstone: [
      {
        maxPrize: '10.8K',
        playersMax: 6,
        roundTime: 90,
        buyInAmount: 2000,
      },
    ],
    'mission-amazon': [
      {
        maxPrize: '10.8K',
        playersMax: 6,
        roundTime: 90,
        buyInAmount: 2000,
      },
    ],
    'rolling-21': [
      {
        maxPrize: '16.2K',
        playersMax: 9,
        roundTime: 10,
        buyInAmount: 2000,
      },
    ],
    'roll-or-hold': [
      {
        maxPrize: '16.2K',
        playersMax: 9,
        roundTime: 20,
        buyInAmount: 2000,
      },
    ],
    'escape-the-circle': [
      {
        maxPrize: '7.2K',
        playersMax: 4,
        roundTime: 20,
        buyInAmount: 2000,
      },
    ],
    'escape-the-circle-xtreme': [
      {
        maxPrize: '14.4K',
        playersMax: 8,
        roundTime: 20,
        buyInAmount: 2000,
      },
    ],
    'scarab-plinko': [
      {
        maxPrize: '9K',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 2000,
      },
    ],
    'max-blocks': [
      {
        maxPrize: '9K',
        playersMax: 10,
        roundTime: 20,
        buyInAmount: 2000,
      },
    ],
    maxplosion: [
      {
        maxPrize: '7.2K',
        playersMax: 4,
        roundTime: 120,
        buyInAmount: 2000,
      },
    ],
    'duel-21': [
      {
        maxPrize: '90K',
        playersMax: 50,
        roundTime: 240,
        buyInAmount: 2000,
      },
    ],
  },
};

export function sortPvpGames(games) {
  const sortOrder = {
    'Multi Plinko': 1,
    'Multi Mines': 2,
    'Max Blast Champs': 3,
    'Sector X': 4,
    'Mission Amazon': 5,
    'Dragon Stone': 6,
    'Roll Or Hold': 7,
    'Rolling 21': 8,
    'Escape The Circle': 9,
    'Duel 21': 10,
    'Escape the Circle Xtreme': 11,
  };
  return games.sort((a, b) => (sortOrder[a.title] || Infinity) - (sortOrder[b.title] || Infinity));
}

export function sortFastplayGames(games) {
  const sortOrder = {
    'Fast Mines': 1,
    'Triple Max Blast': 2,
    'Sector X': 3,
    'Mission Amazon': 4,
    'Dragon Stone': 5,
    'Olympus Plinko': 6,
  };
  return games.sort((a, b) => (sortOrder[a.title] || Infinity) - (sortOrder[b.title] || Infinity));
}

export function sortFishTableGames(games) {
  const sortOrder = {
    'Sector X': 1,
    'Mission Amazon': 2,
    'Dragon Stone': 3,
  };
  return games.sort((a, b) => (sortOrder[a.title] || Infinity) - (sortOrder[b.title] || Infinity));
}
